import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BlogService } from 'src/app/api/blog.service';
import { BlogPost, BlogPostType } from 'src/app/models/blog';

@Component({
  selector: 'app-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss']
})
export class PageComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private blogService: BlogService) { }


  loading = false;
  data: BlogPost;

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.getData(params.get('key'));
    });
  }

  getData(key: string) {
    this.loading = true;
    this.data = null;

    this.blogService.getOne({
      type: BlogPostType.Page,
      slug: key,
      slugLocale: true
    }).subscribe(response => {
      this.loading = false;
      this.data = response;
    }, err => {
      this.loading = false;
      this.router.navigate(['404']);
    });
  }
}
